
import { jsPDF } from "jspdf";
// eslint-disable-next-line no-unused-vars
import autoTable from "jspdf-autotable";
import { asArray, isValid } from "../../page/utils";
import { numatexto } from "../utils";
import config from "../../../config";

/**
 * @param { {
 *   company: string,
 *   code: string,
 *   logoUrl?: string, // URL del logo de la empresa
 *   header: [{
 *     invoicecode: string,
 *     ncf_expiration: string,
 *     ncf: string,
 *     salescode: string,
 *     fecha: string,
 *     status: string,
 *     purpose: string,
 *     custcode: string,
 *     customer_code: string,
 *     name: string,
 *     credit_limit: string,
 *     credit_days: string,
 *     ncf_type: string,
 *     documento: string,
 *     documento_numero: string,
 *     notas: string,
 *     net: string,
 *     itbis: string,
 *     total: string,
 *     invoicedate: string
 *   }],
 *   line: [{
 *     net_amount: string,
 *     itbis_amount: string,
 *     line_amount: string,
 *     product: string,
 *     code: string,
 *     name: string,
 *     itbis: string,
 *     unit: string,
 *     qty: string,
 *     price: string
 *   }],
 *   payment: [{
 *     amount: string,
 *     mode: string
 *   }]
 * } props
 */
function recibo(props) {
	const param = props;

	function parseDate(dateString = "") {
		if (!dateString) return undefined;

		return dateString.length <= 10 ? new Date(`${dateString}T00:00:00`) : new Date(dateString)
	}

	function formatDate(dateOrString = "") {
		const date = dateOrString instanceof Date ? dateOrString : parseDate(dateOrString)

		if (!date) return "";

		return date.toLocaleDateString("es-DO");
	}

	function formatNumber(num) {
		return Number(num).toLocaleString("es-DO", {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}

	function formatCurrency(num) {
		return `RD$ ${formatNumber(num)}`;
	}

	var doc = new jsPDF({ format: "letter", orientation: "portrait" });
	var docWidth = doc.internal.pageSize.width;
	var marginX = 20;
	var marginY = 20;
	var currentHeight = marginY + 6;
	//var docFooter = doc.internal.pageSize.height - marginY;

	var pdfConfig = {
		headerTextSize: 16,
		subHeaderTextSize: 14,
		labelTextSize: 12,
		fieldTextSize: 10,
		smallTextSize: 9,
		lineHeight: 6,
		subLineHeight: 4,
	};

	// Datos de la empresa
	const empresa = isValid(param.companyinfo) ? asArray(param.companyinfo)[0] : {
		nombre: "Papelería Doble K, SRL",
		rnc: "131-48937-2",
		contacto: "papeleriadoblek@gmail.com",
		telefono: "(809) 793-9595",
		direccion: "Calle Wenceslao Álvarez, casi esq. Juan Sánchez Ramírez, Zona Universitaria, Santo Domingo, D.N. Local 101.",
		logo: "F5C3E49E-B940-4D5A-BE60-FDCE470A4AC4"
	};


	// Header de la factura
	const headerData = param.header[0];
	const paymentData = param.payment[0];


	function agregarRecibo(naturaleza = "Original") {
		const currentMarginY = currentHeight - 6

		// Logo de la empresa (si existe)
		if (empresa.logo) {
			try {
				doc.addImage(
					`${config.apiUrl}/file/${empresa.logo}`,
					'PNG',
					marginX + 1,
					currentHeight - 7,
					44,
					24,
					undefined,
					'FAST'
				);
			} catch (error) {
				console.warn('Error al cargar el logo:', error);
			}
		}

		let borderRight = docWidth - marginX - 3
		let borderLeft = marginX + 2

		// Título principal - más grande
		doc.setFontSize(pdfConfig.headerTextSize);
		doc.setFont("helvetica", "bold");
		doc.text("RECIBO DE PAGO", borderRight, currentHeight + 2, { align: "right" });
		currentHeight += 10;


		currentHeight += 8;

		// Número de factura - más prominente
		doc.setFontSize(pdfConfig.labelTextSize);
		doc.setFont("helvetica", "bold");
		doc.text(`Recibo #: ${headerData.receiptcode || param.code}`, borderRight, currentHeight, { align: "right" });


		//currentHeight -= 10

		doc.setFontSize(pdfConfig.labelTextSize);
		doc.setFont("helvetica", "normal");
		doc.text(empresa.nombre, borderLeft, currentHeight, { align: "left" });
		currentHeight += 5;

		doc.text(`RNC ${empresa.rnc}`, borderLeft, currentHeight, { align: "left" });
		currentHeight += 5;

		const fechaEmision = formatDate(headerData.receiptdate);


		doc.setFontSize(pdfConfig.labelTextSize);
		doc.setFont("helvetica", "normal");
		doc.text(`Fecha: ${fechaEmision}`, borderLeft, currentHeight, { align: "left" });
		// Fin header empresa

		currentHeight += 0;


		borderLeft += 1
		borderRight -= 1

		const labelX = 60
		const valueX = 170
		const textWidth = 90
		const valueWidth = 42

		currentHeight += 10;

		doc.setDrawColor(200)

		doc.setFont("helvetica", "normal");
		doc.setFontSize(pdfConfig.fieldTextSize);
		doc.text("Hemos recibido de:", labelX - 1, currentHeight, { align: "right" });

		doc.setFont("helvetica", "normal");
		doc.setFontSize(pdfConfig.labelTextSize);

		const nombreEmisor = doc.splitTextToSize(`${headerData.name} (${headerData.documento_numero})`, textWidth);
		doc.text(nombreEmisor, labelX + 1, currentHeight, { align: "left" });

		doc.setFont("helvetica", "bold");
		doc.setFontSize(pdfConfig.labelTextSize);
		doc.text(paymentData.mode.toUpperCase(), valueX + 1, currentHeight, { align: "center" });

		doc.rect(labelX, currentHeight - 5, textWidth, pdfConfig.lineHeight * nombreEmisor.length + 1, "S")
		doc.rect(labelX + textWidth, currentHeight - 5, valueWidth, pdfConfig.lineHeight * nombreEmisor.length + 1, "S")

		currentHeight += pdfConfig.lineHeight * nombreEmisor.length;
		currentHeight += 1;


		doc.setFont("helvetica", "normal");
		doc.setFontSize(pdfConfig.fieldTextSize);
		doc.text("La suma de:", labelX - 1, currentHeight, { align: "right" });

		const montoTexto = doc.splitTextToSize(numatexto(+paymentData.amount), textWidth);
		doc.text(montoTexto, labelX + 1, currentHeight);

		doc.setFontSize(pdfConfig.labelTextSize);
		doc.text(formatCurrency(+paymentData.amount), valueX + 1, currentHeight, { align: "center" });


		doc.rect(labelX, currentHeight - 5, textWidth, pdfConfig.lineHeight * montoTexto.length, "S")
		doc.rect(labelX + textWidth, currentHeight - 5, valueWidth, pdfConfig.lineHeight * montoTexto.length, "S")


		currentHeight += pdfConfig.lineHeight * montoTexto.length;
		currentHeight += 2;

		doc.rect(labelX, currentHeight - 5, textWidth, 7, "S")

		doc.setFont("helvetica", "normal");
		doc.setFontSize(pdfConfig.fieldTextSize);
		doc.text("Por concepto de:", labelX - 1, currentHeight, { align: "right" });

		const montoConcepto = headerData.notas || ""
		doc.text(montoConcepto, labelX + 1, currentHeight, { align: "left" });

		doc.setDrawColor(0)

		currentHeight += 20;

		// Firmas
		doc.setFontSize(pdfConfig.smallTextSize);
		doc.setFont("helvetica", "normal");
		const firmaX1 = marginX;
		const firmaX2 = docWidth - marginX - 60 - 1;

		doc.setTextColor(150);
		doc.text("Entregado:", firmaX1 + 2, currentHeight);

		doc.text("Recibido:", firmaX2 + 2, currentHeight);


		doc.setTextColor(10)
		// Líneas para firmas
		doc.line(firmaX1, currentHeight + 3, firmaX1 + 60, currentHeight + 3);
		doc.line(firmaX2, currentHeight + 3, firmaX2 + 60, currentHeight + 3);

		currentHeight += 12;

		// Información de contacto - con separador
		doc.setFontSize(pdfConfig.fieldTextSize);
		doc.setFont("helvetica", "normal");
		doc.text(naturaleza, docWidth / 2, currentHeight, { align: "center" });

		doc.setFont("helvetica", "bold");
		doc.setFontSize(pdfConfig.smallTextSize);
		doc.text(param.code, borderRight, currentHeight, { align: "right" });

		doc.rect(marginX, currentMarginY, docWidth - marginX * 2 - 1, currentHeight - currentMarginY + 2, "S")
	}

	agregarRecibo("Original")

	currentHeight += 25

	agregarRecibo("Copia")

	return doc;
}

export default recibo;